import React from "react";

function Leadership() {
  return (
    <div>
      <section className="common-page-hero">
        <img
          src="./assets/img/service/l12.jpeg"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        translate: "none",
                        rotate: "none",
                        scale: "none",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      Leadership
                    </div>
                  </div>
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                World-class Industry Relevant Training
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Leadership
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>

      <section>
        <div className="about-us-content-bg" style={{ marginTop: "20px" }}>
          <div className="container">
            <div className="about-us-content">
              <div className="image-content">
                <img
                  className="about-img-1"
                  src="./assets/img/service/service_9.png"
                  alt="..."
                  style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transform: "translate3d(0px, 0.8079px, 0px)",
                  }}
                />
              </div>
              <div className="info-content">
                <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                  <h3 style={{ fontSize: "43px" }}>
                    Leadership Team at SEMANTIC
                  </h3>
                  <ul
                    style={{
                      textAlign: "justify",
                      fontSize: "17px",
                      marginTop: "9px",
                    }}
                  >
                    <li>
                      <strong>The Leadership Team at SEMANTIC</strong> brings
                      over 100 years of combined semiconductor design and
                      manufacturing experience, making us pioneers in the
                      industry.
                    </li>
                    <li>
                      With <strong>17 years</strong> spent at leading overseas
                      manufacturing plants, the team has a deep understanding of
                      global best practices and cutting-edge technologies.
                    </li>
                    <li>
                      Our wealth of expertise spans the entire semiconductor
                      lifecycle, from design to manufacturing and testing,
                      ensuring a holistic approach to innovation.
                    </li>
                    <li>
                      The advisory board further strengthens SEMANTIC's
                      capabilities, featuring eminent experts in IC design,
                      wafer fabrication, facilities management, and assembly.
                    </li>
                    <li>
                      This combination of hands-on leadership and world-class
                      advisory talent positions SEMANTIC as a leader in the
                      semiconductor training/consulting space.
                    </li>
                    <li>
                      By leveraging our vast knowledge and global experience, we
                      continuously drive growth, quality, and operational
                      excellence, providing unmatched value to clients.
                    </li>
                    <li>
                      SEMANTIC's Leadership Team and advisory board are
                      committed to shaping the future of semiconductor
                      manufacturing education and consulting in India.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="testmonial-content" style={{ marginTop: "20px" }}>
            <div className="testmonial-slider">
              <div className="testmonial-img">
                <img
                  src="./assets/img/bg/l2.png"
                  alt="..."
                  style={{ marginTop: "20px" }}
                />
              </div>
              <div className="testmonial-info">
                <p className="testmonial-shot-title">
                  Commitment to Excellence and Industry Growth
                </p>
                <div style={{ height: "40px" }}></div>
                <h3 className="testmonial-title" style={{ fontSize: "38px" }}>
                  <p style={{ textAlign: "justify" }}>
                    Through our extensive knowledge and global experience, we
                    cultivate industry pioneers who drive technology, quality,
                    productivity and innovation in the semiconductor industry.
                  </p>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        style={{
          backgroundColor: "rgb(245, 245, 245)",
          minHeight: "100vh",
          padding: "40px 20px",
        }}
      >
        <div
          className="board-container"
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            animation: "fadeIn 0.8s ease-out",
          }}
        >
          <header
            className="header"
            style={{
              textAlign: "center",
              marginBottom: "60px",
              position: "relative",
              backgroundColor: "#000",
              padding: "30px",
              borderRadius: "10px",
              color:"white"
            }}
          >
            <h1
              className="title"
              style={{
                fontSize: "42px",
                color: "white",
                margin: 0,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Board of Directors
            </h1>
          </header>

          <div>
            <div
              className="profile-card responive_profile_Card"
              style={{
                background: "white",
                borderRadius: "15px",
                padding: "30px",
                marginBottom: "40px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                gap: "40px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                className="image-container"
                style={{
                  flexShrink: 0,
                  width: "300px",
                  height: "400px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                }}
              >
                <img
                  src="./assets/img/service/man12.jpeg"
                  alt="Krishna Moorthy K"
                  className="profile-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
              <div className="content">
                <h2
                  className="name"
                  style={{
                    fontSize: "32px",
                    color: "#000",
                    margin: "0 0 10px 0",
                    fontWeight: 700,
                    background: "linear-gradient(90deg, #ffd700, #ff8c00)",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    display: "inline-block",
                  }}
                >
                  Krishna Moorthy K
                </h2>
                <h3
                  className="role"
                  style={{
                    fontSize: "20px",
                    color: "#000",
                    margin: "0 0 25px 0",
                    fontWeight: 500,
                    paddingBottom: "15px",
                    borderBottom: "2px solid #ffd700",
                  }}
                >
                  Director - Board Member
                </h3>
                <div class="description" style={{textAlign:"justify"}}>
                  <p>
                    Mr. Krishna Moorthy is a highly accomplished Electronics
                    professional with experience at Managing Director &amp;
                    Corporate VP levels in Semiconductor MNCs. He has expertise
                    in corporate management, finance, compliance (SoX, transfer
                    pricing), HR processes, and board-level functions in both
                    Indian private and public companies. Krishna is widely
                    recognized for strategic vision setting and tactical
                    execution to create high-performing organizations and manage
                    projects or turnarounds. He has over 40 years of global
                    experience in ASIC, SoC, and hardware system design across
                    consumer, industrial, wireless, and compute domains. His
                    experience spans a wide range of functions including silicon
                    design, system design, quality systems, corporate functions,
                    and operations management.
                  </p>
                  <p>
                    Most recently, Krishna led IESA (India Electronics &amp;
                    Semiconductor Association) from 2020-2023, representing 300+
                    members, including global companies and startups.
                  </p>
                  <p>
                    He was also its Honorary Vice Chairman and Chairman earlier,
                    connecting with government establishments and leading a
                    professional body of 500+ Indian electronics companies.
                  </p>
                  <p>
                    Krishna is the recipient of multiple awards, including IEEE
                    India Technologist of the Year 2019, for leadership and
                    team-building in collaborative environments.
                  </p>
                  <p>
                    As Corporate VP &amp; MD at Rambus, he grew India Design
                    Center from 50 to 500 employees, managing engineering,
                    corporate functions, and cross-functional collaborations.
                  </p>
                  <p>
                    Previous leadership roles include Managing Director at
                    National Semiconductor and Director of Engineering at Texas
                    Instruments after their acquisition of National
                    Semiconductor.
                  </p>
                  <p>
                    Krishna also served in Bharat Electronics Ltd., where he
                    developed advanced communication and encryption systems for
                    defense applications.
                  </p>
                  <p>
                    He holds a BE in Electronics and Communication,
                    certifications in DSP, IC design, corporate finance, and
                    leadership, with multiple patents and awards in product
                    development.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="profile-card responive_profile_Card"
              style={{
                background: "white",
                borderRadius: "15px",
                padding: "30px",
                marginBottom: "40px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                
                gap: "40px",
                
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                className="image-container"
                style={{
                  flexShrink: 0,
                  width: "300px",
                  height: "400px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                }}
              >
                <img
                  src="./assets/img/service/soma.jpg"
                  alt="Somashekhar Basavaraj"
                  className="profile-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
              <div className="content">
                <h2
                  className="name"
                  style={{
                    fontSize: "32px",
                    color: "#000",
                    margin: "0 0 10px 0",
                    fontWeight: 700,
                    background: "linear-gradient(90deg, #ffd700, #ff8c00)",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    display: "inline-block",
                  }}
                >
                  Somashekhar Basavaraj
                </h2>
                <h3
                  className="role"
                  style={{
                    fontSize: "20px",
                    color: "#000",
                    margin: "0 0 25px 0",
                    fontWeight: 500,
                    paddingBottom: "15px",
                    borderBottom: "2px solid #ffd700",
                  }}
                >
                  Director - Board Member
                </h3>
                <div class="description" style={{textAlign:"justify"}}>
                  <p>
                    Mr. Somashekhar Basavaraj has 40 years of experience in
                    Electronics &amp; Semiconductors. He is a serial
                    entrepreneur with expertise in IC Design and electronics
                    solutions for industrial and medical applications. Soma has
                    held leadership roles in VLSI, focusing on infrastructure
                    and ecosystem development in India.
                  </p>
                  <p>
                    He is passionate about indigenizing technology in India,
                    including for Electric Vehicles in the automotive sector.
                  </p>
                  <p>
                    Soma was Senior Vice President at Tessolve Semiconductors,
                    leading a large VLSI Design team. Prior to Tessolve, he
                    co-founded ANALOGSEMI, providing analog &amp; mixed-signal
                    IC design services.
                  </p>
                  <p>
                    He was also Technology Manager at Tata Elxsi, overseeing
                    VLSI design and business development for semiconductor tech.
                    Soma led the Analog team at GE Global Research Centre,
                    working on industrial and medical applications. Soma started
                    his career with Bharat Electronics Ltd (BEL), a pioneer in
                    the Indian Semiconductors Industry where he designed
                    multiple analog ICs, headed Photomask Production and played
                    a strategic role in setting up VLSI Design infrastructure
                    &amp; Semiconductor manufacturing facility, working closely
                    with Wafer Fabs, Assembly, Packaging &amp; Testing teams.
                  </p>
                  <p>
                    He holds 5 approved patents on analog interface circuits and
                    control systems. Soma holds a Bachelor's in Electronics
                    Engineering from Mysore University and an MS in
                    Microelectronics from Bircham University, Spain.
                  </p>
                </div>
              </div>
            </div>
{/* 
            <div
              className="profile-card responive_profile_Card"
              style={{
                background: "white",
                borderRadius: "15px",
                padding: "30px",
                marginBottom: "40px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                gap: "40px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                className="image-container"
                style={{
                  flexShrink: 0,
                  width: "300px",
                  height: "400px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                }}
              >
                <img
                  src="./assets/img/service/Naidu.jpeg"
                  alt="Somashekhar Basavaraj"
                  className="profile-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
              <div className="content">
                <h2
                  className="name"
                  style={{
                    fontSize: "32px",
                    color: "#000",
                    margin: "0 0 10px 0",
                    fontWeight: 700,
                    background: "linear-gradient(90deg, #ffd700, #ff8c00)",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    display: "inline-block",
                  }}
                >
                  Jagannadham Naidu Amballa
                </h2>
                <h3
                  className="role"
                  style={{
                    fontSize: "20px",
                    color: "#000",
                    margin: "0 0 25px 0",
                    fontWeight: 500,
                    paddingBottom: "15px",
                    borderBottom: "2px solid #ffd700",
                  }}
                >
                  Director - Board Member
                </h3>
                <div class="description" style={{textAlign:"justify"}}>
                  <p >
                    <b>Mr. Naidu Amballa </b>brings over 17 years of extensive
                    experience in the semiconductor manufacturing industry, with
                    a distinguished career in Singapore. He has successfully led
                    and managed numerous Diffusion process module projects,
                    including the qualification of alternate chemical sources,
                    critical hardware and equipment such as advanced wet benches
                    (KAIJO, DNS), wafer backside cleaning systems (SEZ, Nexgen),
                    and wafer ID marking tools. His expertise also extends to
                    the qualification of new chemical and ultrapure water (UPW)
                    lines.{" "}
                  </p>
                  <br />
                  <p>
                    A champion of process optimization, Mr. Naidu has played a
                    key role in multiple initiatives targeting defect reduction,
                    contamination prevention, and cost savings. His
                    problem-solving excellence has been recognized with several
                    performance awards, driven by his application of
                    methodologies such as Six Sigma, 3×5 Why, 8D, and FMEA
                    analysis. He has also led continuous improvements in the
                    Diffusion Module’s Wet bench defense systems and operating
                    procedures.{" "}
                  </p>
                  <br />
                  <p>
                    Known for his collaborative spirit and positive leadership
                    style, he has mentored new Diffusion process engineers and
                    built strong cross-functional relationships across
                    departments. As a subject matter expert in Diffusion/Wet
                    module, he has been instrumental in developing new
                    technologies—from understanding process requirements and
                    defining specifications, to designing experiments, recipe
                    development, and margin analysis.{" "}
                  </p>
                  <br />
                  <p>
                    <b>Mr. Naidu </b>has successfully partnered with global
                    teams from NXP Netherlands, NXP USA, and TSMC Taiwan on
                    various technology transfer projects, enhancing
                    organizational capabilities and accelerating innovation. He
                    is credited with one trade secret on utility cost reduction
                    and holds a patent for automated recipe selection based on
                    incoming wafer thickness variation. He earned his Bachelor’s
                    degree in Electrical and Electronics Engineering from
                    Jawaharlal Nehru Technological University (JNTU), Hyderabad,
                    and holds a Master’s degree in Control Systems Engineering
                    from the prestigious Indian Institute of Technology (IIT)
                    Kharagpur.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <span className="ak-scrollup">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </div>
  );
}

export default Leadership;
